import { observer } from 'mobx-react-lite';
import Skeleton from 'react-loading-skeleton';
import { Link } from 'react-router-dom';

import { company } from '~/company/Company';
import { useCategoryAnalytics } from '~/hooks/useCategoryAnalytics';
import { useOnWarehouseChange } from '~/hooks/useOnWarehouseChange';
import { catalogStore } from '~/stores/CatalogStore';
import { Category } from '~/stores/CategoriesStore';
import { userStore } from '~/stores/UserStore';

import CategoryBlockTitle from '../CategoryBlockTitle';
import { cfSrcForImage } from '../utils';

import styles from './CategoriesGridThreeMBlock.module.scss';

interface CategoriesGridThreeMBlockProps {
  category: Category;
}

const CategoriesGridThreeMBlockProps = ({
  category,
}: CategoriesGridThreeMBlockProps) => {
  const { handleClickCategory } = useCategoryAnalytics();

  useOnWarehouseChange((_, isChanged) => {
    if (isChanged) {
      category.productsRequest.run();
    }
  });

  if (!category.subcategory.length || !category.subcategory[0]?.id) {
    return null;
  }

  return (
    <div
      key={category.id}
      className={styles.container}
      data-company={company.name}
    >
      <CategoryBlockTitle text={category.name} />
      {category.subcategory.length > 0 ? (
        <div className={styles.tiles}>
          {category.subcategory.map(({ name, previewImage, id, parentId }) => {
            if (!parentId) {
              return null;
            }

            return (
              <div key={name} className={styles.tile} dir={userStore.dir}>
                <Link
                  state={{ clean_filters: true }}
                  to={`/c/${id}`}
                  className={styles.link}
                  onClick={() => {
                    handleClickCategory(parentId)();
                    catalogStore.resetCatalogFilters();
                  }}
                >
                  <div className={styles.imageBlock}>
                    {company.hasGradientTile && (
                      <div className={styles.gradient} />
                    )}
                    <img
                      className={styles.image}
                      src={cfSrcForImage(previewImage, {
                        width: 208,
                        height: 182,
                      })}
                    />
                  </div>
                  <div className={styles.title}>{name}</div>
                </Link>
              </div>
            );
          })}
        </div>
      ) : (
        <Skeleton
          count={3}
          className={styles.tile}
          containerClassName={styles.tiles}
          inline={true}
        />
      )}
    </div>
  );
};

export default observer(CategoriesGridThreeMBlockProps);
